
function ajaxURL() {
  if (window.IsStyleGuide) {
    return {
      dicokey: '/ajax/dicokey.html',
      getBeautyProfileReviews: '/ajax/getBeautyProfileReviews.json',
      getSvsResponses: '/ajax/getSvsResponses.json',
      sentCommentReviews: '/ajax/sentCommentReviews.json',
      usefulCommentVoteReviews: '/ajax/usefulCommentVoteReviews.json',
      filterListReviews: '/ajax/filterListReviews.html',
      getMoreReviews: '/ajax/getMoreReviews.html',
      search: 'https://stage.ocms.loccitane.com/ajax/UtilsAjax.aspx',
      storesJson: 'https://usa.loccitane.com/tools/datafeeds/StoresJSON.aspx',
      getStockStoresProductPage: 'https://fr.loccitane.com/ajax/UtilsAjax.aspx',
      googleDistanceApi: 'https://maps.googleapis.com/maps/api/distancematrix/json',
      shareToFriends: 'https://stage.ocms.loccitane.com/ajax/UtilsAjax.aspx',
      getStockStoresStorePage: '/ajax/getStockStoresStorePage.json',
      productSearchRequestStorePage: '/ajax/productSearchRequestStorePage.html',
      getbag: 'https://stage.ocms.loccitane.com/ajax/Desktop.aspx',
      ecomBag: '/ajax/ecomBag_Ajax.aspx',
      addToWishList: 'https://stage.ocms.loccitane.com/ajax/UtilsAjax.aspx',
      removeFromWishList: 'https://stage.ocms.loccitane.com/ajax/UtilsAjax.aspx',
      autoReplenishment: 'https://stage.ocms.loccitane.com/ajax/AutoReplenishment_Ajax.aspx',
      ordersHistory: 'https://stage.ocms.loccitane.com/ajax/UtilsAjax.aspx',
      getAddToBagPopin: 'https://test-redesign.ocms.redesign2016.stage.occitane.msp.fr.clara.net/ajax/v2/ProductPageAjax.aspx',
      reminderPopin: 'https://test-redesign.ocms.redesign2016.stage.occitane.msp.fr.clara.net/ajax/UtilsAjax.aspx',
      pwdReminder: 'https://test-redesign.ocms.redesign2016.stage.occitane.msp.fr.clara.net/ajax/UtilsAjax.aspx',
      formatprice: 'https://test-redesign.ocms.redesign2016.stage.occitane.msp.fr.clara.net/ajax/ecombag_ajax.aspx',
      deleteSubscription: 'https://test-redesign.ocms.redesign2016.stage.occitane.msp.fr.clara.net/ajax/UtilsAjax.aspx',
      paymentTokenService: 'https://test-redesign.ocms.redesign2016.stage.occitane.msp.fr.clara.net/ajax/PaymentTokenService.aspx',
      callMeBack: 'http://stage.ocms.loccitane.com/ajax/UtilsAjax.aspx',
      nlpcookieupdate: 'http://test-redesign.ocms.redesign2016.stage.occitane.msp.fr.clara.net/ajax/ecombag_ajax.aspx',
      subscribenewsletter: 'http://test-redesign.ocms.redesign2016.stage.occitane.msp.fr.clara.net/ajax/ecombag_ajax.aspx',
      validateEmailAddress: 'http://test-redesign.ocms.redesign2016.stage.occitane.msp.fr.clara.net/ajax/ecombag_ajax.aspx',
      checkifemailexists: 'http://test-redesign.ocms.redesign2016.stage.occitane.msp.fr.clara.net/ajax/UtilsAjax.aspx',
      footernewsletter: 'http://test-redesign.ocms.redesign2016.stage.occitane.msp.fr.clara.net/ajax/UtilsAjax.aspx',
      optinRewardWithinCheckout: 'http://test-redesign.ocms.redesign2016.stage.occitane.msp.fr.clara.net/ajax/rewards_Ajax.aspx',
      getProductPageShippingMethod: 'http://test-redesign.ocms.redesign2016.stage.occitane.msp.fr.clara.net/ajax/ecomBag_Ajax.aspx',
      getOrderTrackingEvents: 'http://test-redesign.ocms.redesign2016.stage.occitane.msp.fr.clara.net/ajax/ecomBag_Ajax.aspx',
      gdprAjax: '/ajax/Gdpr_Ajax.aspx',
      checkStocks: '/ajax/UtilsAjax.aspx',
      getDeliverySlots: '/ajax/ecombag_Ajax.aspx',
      getGiftCardBalanceCheck: '/ajax/UtilsAjax.aspx',
    };
  }

  return {
    dicokey: '/ajax/UtilsAjax.aspx',
    getBeautyProfileReviews: '/ajax/Desktop.aspx',
    sentCommentReviews: '/ajax/Desktop.aspx',
    usefulCommentVoteReviews: '/ajax/Desktop.aspx',
    filterListReviews: '/ajax/v2/ProductReview.aspx',
    getMoreReviews: '/ajax/v2/ProductReview.aspx',
    search: '/ajax/UtilsAjax.aspx',
    storesJson: '/tools/datafeeds/StoresJSON.aspx',
    getStockStoresProductPage: '/ajax/UtilsAjax.aspx',
    googleDistanceApi: 'https://maps.googleapis.com/maps/api/distancematrix/json',
    shareToFriends: '/ajax/UtilsAjax.aspx',
    getStockStoresStorePage: '/ajax/utilsajax.aspx',
    productSearchRequestStorePage: '/ajax/v2/StorePageProductQuickSearch.aspx',
    getbag: '/ajax/V2/CartManager.aspx',
    ecomBag: '/ajax/ecomBag_Ajax.aspx',
    addToWishList: '/ajax/UtilsAjax.aspx',
    removeFromWishList: '/ajax/UtilsAjax.aspx',
    autoReplenishment: '/ajax/AutoReplenishment_Ajax.aspx',
    ordersHistory: '/ajax/UtilsAjax.aspx',
    getAddToBagPopin: '/ajax/v2/ProductPageAjax.aspx',
    reminderPopin: '/ajax/UtilsAjax.aspx',
    pwdReminder: '/ajax/UtilsAjax.aspx',
    formatprice: '/ajax/ecombag_ajax.aspx',
    utilsAjax: '/ajax/UtilsAjax.aspx',
    skincareDiagnosisAjax: '/ajax/SkincareDiagnosis_Ajax.aspx',
    deleteSubscription: '/ajax/UtilsAjax.aspx',
    paymentTokenService: '/ajax/PaymentTokenService.aspx',
    callMeBack: '/ajax/UtilsAjax.aspx',
    nlpcookieupdate: '/ajax/ecombag_ajax.aspx',
    subscribenewsletter: '/ajax/ecombag_ajax.aspx',
    validateEmailAddress: '/ajax/ecombag_ajax.aspx',
    checkifemailexists: '/ajax/UtilsAjax.aspx',
    footernewsletter: '/ajax/UtilsAjax.aspx',
    optinRewardWithinCheckout: '/ajax/rewards_Ajax.aspx',
    getProductPageShippingMethod: '/ajax/ecomBag_Ajax.aspx',
    getOrderTrackingEvents: '/ajax/ecomBag_Ajax.aspx',
    gdprAjax: '/ajax/Gdpr_Ajax.aspx',
    checkStocks: '/ajax/UtilsAjax.aspx',
    getDeliverySlots: '/ajax/ecombag_Ajax.aspx',
    getGiftCardBalanceCheck: '/ajax/UtilsAjax.aspx',
    seniorShipping: '/ajax/SeniorAjax.aspx',
    getCredentialsCheck: '/ajax/CredentialsCheck.aspx'
  };
}

const url = ajaxURL();

export default url;



// WEBPACK FOOTER //
// ./js/common/AjaxURL.js